export const numberSorter = (a?: number | null, b?: number | null): number => {
  if (a == null) {
    return -1;
  }

  if (b == null) {
    return 1;
  }

  return a - b;
};
